import { createAction } from '@reduxjs/toolkit'
import { SnackbarInterface } from 'models/interfaces/snackbar.interface'

export const showSnackbar = createAction<boolean>('snackbar/showSnackbar')
export const showMessage = createAction<SnackbarInterface>('snackbar/showMessage')
